import { render, staticRenderFns } from "./cardsList.vue?vue&type=template&id=3017ca21&scoped=true&"
import script from "./cardsList.vue?vue&type=script&lang=js&"
export * from "./cardsList.vue?vue&type=script&lang=js&"
import style0 from "./cardsList.vue?vue&type=style&index=0&id=3017ca21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3017ca21",
  null
  
)

export default component.exports